export default __webpack_public_path__ + "static/media/TheSimurghMountain_by_vodanova.7d8d61d3.mp4";